import { render, staticRenderFns } from "./pageKV.vue?vue&type=template&id=6f064b25&scoped=true&"
import script from "./pageKV.vue?vue&type=script&lang=js&"
export * from "./pageKV.vue?vue&type=script&lang=js&"
import style0 from "./pageKV.vue?vue&type=style&index=0&id=6f064b25&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f064b25",
  null
  
)

export default component.exports